import { QBox } from '@qualio/ui-components';
import { Page } from 'react-pdf';

export const XlsxPage = ({
  zoom,
  pageNumber,
  containerWidth,
  containerHeight,
}: {
  zoom: number;
  pageNumber: number;
  containerWidth?: number;
  containerHeight?: number;
}) => {
  return (
    <QBox
      height="100%"
      maxWidth={containerWidth}
      maxHeight={containerHeight}
      border="1px"
      boxShadow="md"
      borderColor="gray.200"
      overflow="scroll"
    >
      <Page
        scale={zoom}
        pageNumber={pageNumber}
        renderTextLayer={false}
        renderAnnotationLayer={false}
      />
    </QBox>
  );
};
